import { PermissionOption } from 'interfaces/permissionOption';
import { apiRequestHandlerPromise } from 'utils/apiRequestHandler';

export const getPermissionOptions = () => {
  return apiRequestHandlerPromise<PermissionOption[]>({
    url: `users/permission_options`,
    method: 'GET',
  });
};
